 /**
 * Created by tofael on 3/23/17.
 */

import React from 'react';
import { Route, IndexRoute } from 'react-router';

import App from './containers/app';
import Attendance from './containers/attendance';
import NotFoundPage from './screens/shared/not-found.js';
import LoginPage from './containers/login';
import ResetPassword from './containers/reset-password';
import Applications from './containers/doctor-applications';
import Doctors from './containers/doctors';
import Consumers from './containers/consumers';
import ConsumerDetails from './containers/consumer-details';
import DoctorProfile from './containers/doctor-profile';
import CreateAdmin from './containers/create-admin';
import CreateDoctor from './containers/create-doctor';
import OperatorProfile from './containers/user-profile';
import PendingPayments from './containers/pending-payment'
import Operators from './containers/operators';
import VisitingDoctors from './containers/visiting-doctors'
import Missions from './containers/missions';
import Calls from './containers/calls';
import Admins from './containers/admins';
import ViewMission from './containers/mission-view';
import Stats from './containers/stats';
import Tips from './containers/tips';
import CreateTip from './containers/create-tip';
import AppointmentsView from './containers/appointments';

import { isUserAuthenticated } from './utility/local-storage'
import Scheduler from './containers/schedules';
import Specialities from './containers/specialities';
import createSpeciality from './containers/create-speciality';
function verifyAuth (nextState, replace) {
  let loginPath = '/login';
  let pathname = nextState.location.pathname+nextState.location.search;
  if(!(pathname.substr(0, loginPath.length).toUpperCase() === loginPath.toUpperCase()) && !isUserAuthenticated()) {
    if (pathname !== '/') {
      replace({
        pathname: loginPath,
        state: { nextPathname: pathname }
      })
    } else {
      replace(loginPath);
    }
  }
}

export default (
    <Route>
      <Route path="/login" component={LoginPage}/>
      <Route path="/password-reset" component={ResetPassword}/>
      <Route path="/" component={App} onEnter={verifyAuth}>
        <IndexRoute component={Doctors}/>
        <Route path="/applications" component={Applications}/>
        <Route path="/attendance" component={Attendance}/>
        <Route path="/doctors" component={Doctors}/>
        <Route path="/doctor/:id" component={DoctorProfile}/>
        <Route path="/user/:id" component={OperatorProfile}/>
        <Route path="/operators" component={Operators}/>
        <Route path="/visiting-doctors" component={VisitingDoctors}/>
        <Route path="/pending-payments" component={PendingPayments}/>
        <Route path="/consumers" component={Consumers}/>
        <Route path="/consumers:id" component={ConsumerDetails}/>
        <Route path="/admins" component={Admins}/>
        <Route path="/missions:id" component={Missions}/>
        <Route path="/missions" component={Missions}/>
        <Route path="/calls" component={Calls}/>
        <Route path="/mission/:id" component={ViewMission}/>
        <Route path="/create-admin" component={CreateAdmin}/>
        <Route path="/create-doctor" component={CreateDoctor}/>
        <Route path="/stats" component={Stats}/>
        <Route path="/tips" component={Tips}/>
        <Route path="/create-tip" component={CreateTip}/>
        <Route path="/schedules" component={Scheduler}/>
        <Route path="/appointments" component={AppointmentsView}/>
        <Route path="/specialities" component={Specialities}/>
        <Route path="/create-speciality" component={createSpeciality}/>
        <Route path="*" component={NotFoundPage}/>
      </Route>
    </Route>
);


// WEBPACK FOOTER //
// ./src/routes.js